// extracted by mini-css-extract-plugin
export default {"price":"r8-z","onSale":"s8-z","msrpLabelPrice":"t8-z","msrpLabel":"u8-z","originalPrice":"v8-z","percentOff":"w8-z"};